/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CustomerOfferStatus} from "./customerOfferStatus.zod";

export const CustomerOfferPermittedAction = zod
  .object({
    action: zod.enum([
      "UPDATE_DRAFT",
      "EDIT_NOTES",
      "SUBMIT",
      "APPROVE_CONTENT",
      "SET_COEFFICIENT",
      "SET_CHAPTER_COMMERCIAL_OPTIONS",
      "COMPLETE_COEFFICIENT_REVIEW",
      "RETURN_TO_COEFFICIENT_REVIEW",
      "RETURN_TO_DRAFT",
      "PREPARE_SEND",
      "SEND",
      "ACCEPT",
      "REJECT",
      "CANCEL",
      "CORRECT_OUTCOME",
      "OBSOLETE",
      "UNDO_OBSOLESCENCE",
      "CREATE_REVISION",
    ]),
    targetStatus: zod.union([CustomerOfferStatus, zod.null()]),
  })
  .describe(
    "Server-derived action hint for captured state and actor, not write authority. Commands atomically recheck actual state, parent and successor. Undo target is the recorded origin, never an assumed Draft destination. SET_CHAPTER_COMMERCIAL_OPTIONS targets unchanged COEFFICIENT_REVIEW and applies to the existing owned Chapters under coefficient authority, without a per-Chapter management decision or pricing-completeness gate. PREPARE_SEND targets the unchanged APPROVED stage; only SEND targets SENT. CREATE_REVISION targets the new DRAFT identity returned by that command, not a restoration of the rejected issued identity. Party eligibility and downstream business guards are rechecked by the command; captured hints do not reacquire current commercial inputs for an issued document.",
  );

export type CustomerOfferPermittedAction = zod.input<typeof CustomerOfferPermittedAction>;
export type CustomerOfferPermittedActionOutput = zod.output<typeof CustomerOfferPermittedAction>;
